<ui-offcanvas
	[closeOnOutsideClick]="true"
	[header]="'detail.title' | translate"
	[open]="open()"
	(closed)="doClose()"
>
	@let el = displayedElement();
	<p class="mb-4 text-sm text-secondary-700" data-cy="selftest-detail-subtitle">
		{{ el?.serialnumber | empty }} · {{ el?.latest | customDate }} {{ el?.latest | customTime }}
	</p>
	<ui-button-toggle
		class="block mb-4"
		[buttons]="viewToggles"
		[formField]="viewField"
		data-cy="selftest-detail-view-toggle"
	>
		<span *uiButtonToggleContent="let button">{{ button.translation | translate }}</span>
	</ui-button-toggle>
	@if (isJsonView()) {
		<p class="mb-2 text-xs text-secondary-700" data-cy="selftest-detail-json-meta">
			{{ 'detail.raw_response' | translate }} · {{ jsonFileName() }} ·
			{{ jsonSizeKb() | customNumber: '1.1-1' }}
			{{ 'detail.kb' | translate }}
		</p>
		<pre
			class="m-0 p-3 rounded-sm border border-secondary-200 bg-secondary-100 font-mono text-xs whitespace-pre-wrap break-all select-text"
			data-cy="selftest-detail-json"
		>@for (token of jsonTokens(); track $index) {<span [class]="token.styleClass">{{ token.text }}</span>}</pre>
	} @else {
		<div class="flex flex-col gap-6">
			<table class="detail__table">
				<tr>
					<td class="font-semibold">{{ 'tests.serial' | translate }}</td>
					<td class="pl-4">{{ el?.serialnumber | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'tests.date' | translate }}</td>
					<td class="pl-4">{{ el?.start | customDate }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'tests.runs' | translate }}</td>
					<td class="pl-4">{{ el?.runs | empty }} / {{ el?.totalRuns ?? (el?.runs | empty) }}</td>
				</tr>
				<tr>
					<td class="pb-3 font-semibold">{{ 'detail.latest' | translate }}</td>
					<td class="pb-3 pl-4">{{ el?.latest | customDate }} {{ el?.latest | customTime }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.uuid' | translate }}</td>
					<td class="pl-4">{{ el?.uuid | empty }}</td>
				</tr>

				<tr>
					<td class="font-semibold">{{ 'detail.wifi_ip' | translate }}</td>
					<td class="pl-4">{{ el?.wifiIp | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.time_avg' | translate }}</td>
					<td class="pl-4">{{ el?.timeAvg | customNumber: '1.2-2' | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.signal_avg' | translate }}</td>
					<td class="pl-4">{{ el?.signalAvg | customNumber: '1.2-2' | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.mem_size' | translate }}</td>
					<td class="pl-4">
						{{ el?.memsize | customNumber: '1.2-2' | empty }} {{ 'detail.gb' | translate }}
					</td>
				</tr>
				<tr>
					<td class="pb-3 font-semibold">{{ 'detail.disk_speed' | translate }}</td>
					<td class="pb-3 pl-4">
						{{ el?.diskSpeed | customNumber: '1.2-2' | empty }} {{ 'detail.mbps' | translate }}
					</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.modem_ip' | translate }}</td>
					<td class="pl-4">{{ el?.modemIp | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.status' | translate }}</td>
					<td class="pl-4">{{ el?.modemStatus | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.iccid' | translate }}</td>
					<td class="pl-4">{{ el?.iccid | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.carrier_id' | translate }}</td>
					<td class="pl-4">{{ el?.carrierId | empty }}</td>
				</tr>
				<tr>
					<td class="font-semibold">{{ 'detail.mac' | translate }}</td>
					<td class="pl-4">{{ el?.mac | empty }}</td>
				</tr>
			</table>
		</div>
	}
	@if (isJsonView()) {
		<ng-container offcanvas-button>
			<ui-button
				[disabled]="!el"
				[fullWidth]="true"
				icon="download"
				[text]="'detail.download_json' | translate"
				(buttonClicked)="downloadJson()"
				data-cy="selftest-detail-download-json"
			></ui-button>
			<ui-button
				[disabled]="!el"
				[fullWidth]="true"
				icon="copy"
				[text]="'detail.copy_json' | translate"
				[type]="copyButtonTheme"
				(buttonClicked)="copyJson()"
				data-cy="selftest-detail-copy-json"
			></ui-button>
		</ng-container>
	}
	<ui-button
		offcanvas-button
		[fullWidth]="true"
		[text]="'detail.close' | translate"
		[type]="closeButtonTheme()"
		(buttonClicked)="doClose()"
		data-cy="selftest-detail-close"
	></ui-button>
</ui-offcanvas>
